export default function Hero() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative w-full min-h-[420px] md:min-h-[600px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20moody%20abstract%20background%20with%20deep%20crimson%20red%20and%20charcoal%20black%20gradient%2C%20dramatic%20lighting%20with%20soft%20spotlight%20effect%2C%20cinematic%20atmosphere%2C%20mysterious%20and%20sophisticated%20tone%2C%20subtle%20texture%20like%20velvet%20curtain%2C%20theatrical%20mood%2C%20professional%20editorial%20style%2C%20no%20text%20or%20logos&width=1800&height=1200&seq=hero-bg-17hl-01&orientation=landscape"
          alt="17黑料网背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/45 to-black/70"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-3 py-1 text-xs md:text-sm font-medium bg-primary-500/20 text-primary-300 rounded-full border border-primary-400/30 mb-4 md:mb-5">
              国产黑料追踪平台
            </span>

            <h1 className="text-2xl md:text-4xl lg:text-5xl font-bold font-heading text-white leading-tight mb-4 md:mb-6">
              17黑料网 — 国产黑料在线观看平台
            </h1>

            <p className="text-base md:text-lg text-white/80 font-medium mb-2">
              国产黑料视频一区高清播放，黑料吃瓜首选
            </p>

            <p className="text-sm md:text-base text-white/70 leading-relaxed max-w-[640px] mx-auto lg:mx-0 mb-2 md:mb-3">
              17黑料网是专业的国产黑料内容聚合平台，覆盖娱乐圈、网红圈、社会热点等多维度黑料资讯。
              我们整合17c国产一区二区黑料在线观看资源，提供高清流畅的国产黑料视频播放体验，
              每日更新最新最热的吃瓜内容，让用户第一时间了解全网黑料动态。
            </p>
            <p className="text-sm text-white/60 leading-relaxed max-w-[640px] mx-auto lg:mx-0 mb-6 md:mb-8">
              当前聚焦：顶流艺人塌房事件持续发酵、网红带货翻车潮、综艺节目幕后揭秘等热门话题。
              平台每日保持高频更新，确保用户不错过任何精彩黑料内容。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-6 md:mb-8">
              <div className="text-center">
                <div className="text-lg md:text-xl font-bold text-accent-400 font-heading">15,000+</div>
                <div className="text-xs text-white/50 mt-1">黑料资源</div>
              </div>
              <div className="w-px h-8 bg-white/15 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-lg md:text-xl font-bold text-accent-400 font-heading">每日更新</div>
                <div className="text-xs text-white/50 mt-1">高频追踪</div>
              </div>
              <div className="w-px h-8 bg-white/15 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-lg md:text-xl font-bold text-accent-400 font-heading">百万用户</div>
                <div className="text-xs text-white/50 mt-1">活跃社区</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#updates"
                onClick={(e) => handleNavClick(e, '#updates')}
                className="w-full sm:w-auto whitespace-nowrap px-6 py-3 bg-primary-500 hover:bg-primary-600 text-white font-semibold text-sm rounded-md transition-colors cursor-pointer text-center"
              >
                查看最新爆料
              </a>
              <a
                href="#ranking"
                onClick={(e) => handleNavClick(e, '#ranking')}
                className="w-full sm:w-auto whitespace-nowrap px-6 py-3 bg-white/10 hover:bg-white/20 text-white font-medium text-sm rounded-md border border-white/20 transition-colors cursor-pointer text-center"
              >
                热度榜单
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[480px] lg:max-w-[520px] shrink-0">
            <div className="relative aspect-[4/3] rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20dramatic%20scene%20with%20dark%20red%20velvet%20curtains%20partially%20opened%20revealing%20a%20spotlight%20on%20an%20empty%20stage%2C%20mysterious%20atmosphere%2C%20theatrical%20lighting%20with%20warm%20golden%20and%20deep%20crimson%20tones%2C%20smoke%20or%20fog%20at%20the%20bottom%2C%20elegant%20and%20sophisticated%20composition%2C%20editorial%20photography%20style%2C%20no%20people%2C%20abstract%20storytelling%20mood&width=1040&height=780&seq=hero-visual-17hl-01&orientation=landscape"
                alt="17黑料网主视觉 - 国产黑料内容平台"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}